import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { generateProductLinkPropsForLoggedOutRetailer } from "@faire/retailer-visitor-shared/lib/generateProductLinkPropsForLoggedOutRetailer";
import { isAdmin } from "@faire/retailer-visitor-shared/lib/isAdmin";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { ProductPagePaths } from "@faire/retailer-visitor-shared/paths/ProductPage";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
export var handleGenerateProductLinkProps = function(queryString, params, filterKeys, location) {
    return function() {
        var token = params.token, brandToken = params.brandToken, impressionId = params.impressionId, selectedProductOptionToken = params.selectedProductOptionToken;
        if (!token) {
            return {
                productUrl: ""
            };
        }
        var productPageLink = ProductPagePaths.index(token, {
            refS: queryString,
            refF: filterKeys,
            productOptionToken: selectedProductOptionToken,
            impressionId: impressionId
        });
        if (isLoggedInRetailer() || isAdmin() || isPrerender()) {
            return {
                productUrl: productPageLink
            };
        }
        // logged out users should not see ref parameters (SEO requirement)
        return generateProductLinkPropsForLoggedOutRetailer({
            productToken: token,
            brandToken: brandToken,
            location: location
        });
    };
};
export var handleGenerateBrandUrl = function(queryString, params) {
    return function() {
        // logged out users should not see ref parameters (SEO requirement)
        var refS = isLoggedInRetailer() ? queryString : undefined;
        var refP = isLoggedInRetailer() && params.productToken ? [
            params.productToken
        ] : undefined;
        return params.brandToken ? brandPage(params.brandToken, {
            refS: refS,
            refP: refP,
            impressionId: params.impressionId
        }) : "";
    };
};
export var useGetItemsPerRowResponsive = function(isSideBarVisible) {
    return isSideBarVisible ? ITEMS_PER_ROW_RESPONSIVE_SIDEBAR_XL_DESKTOP : ITEMS_PER_ROW_RESPONSIVE_XL_DESKTOP;
};
export var ITEMS_PER_ROW_RESPONSIVE = {
    mobileAndAbove: 2,
    tabletAndAbove: 4,
    desktopAndAbove: 5,
    xLargeAndAbove: 5,
    xxLargeDesktop: 5
};
var ITEMS_PER_ROW_RESPONSIVE_SIDEBAR = {
    mobileAndAbove: 2,
    tabletAndAbove: 3,
    desktopAndAbove: 4,
    xLargeAndAbove: 4,
    xxLargeDesktop: 4
};
var ITEMS_PER_ROW_RESPONSIVE_XL_DESKTOP = _object_spread_props(_object_spread({}, ITEMS_PER_ROW_RESPONSIVE), {
    desktopAndAbove: 5,
    xLargeAndAbove: 6,
    xxLargeDesktop: 6
});
var ITEMS_PER_ROW_RESPONSIVE_SIDEBAR_XL_DESKTOP = _object_spread_props(_object_spread({}, ITEMS_PER_ROW_RESPONSIVE_SIDEBAR), {
    desktopAndAbove: 4,
    xLargeAndAbove: 5,
    xxLargeDesktop: 5
});
